import en_US from './en-US';
import zh_CN from './zh-CN';

const locales = {
    'en-US': en_US,
    'zh-CN': zh_CN,
};

export default locales;
